import { clientRepo } from "~/server/apis/client_repo";
import { Product } from "~/server/types/search";

export type HomeV2RouteData = {
  brands: Product[];
};

export async function getHomeV2RouteData(): Promise<HomeV2RouteData> {
  const allBrands = await clientRepo.getProductSearch({ query: "" });

  const brands =
    allBrands?.data?.[0]?.products?.filter(
      (product) => product.voucherProduct.status === "ACTIVE"
    ) || [];

  return {
    brands,
  };
}
